import { PriceChangeType } from "@/graphql/codegen/graphql"

export const priceChangeTypeLabelMap = new Map<PriceChangeType, string>([
  [PriceChangeType.PurchasingCost, "Purchasing Cost"],
  [PriceChangeType.SellingPrice, "Selling Price"],
])
